import React from "react";
import "./DetailRow.scss";

/**
 * DetailRow — Key-value display row (label : value).
 * Use inside cards/detail panels.
 *
 * Props:
 *   label     — left-side label text
 *   value     — right-side value (string or ReactNode)
 *   icon      — optional Lucide icon component
 *   className — extra class
 */
const DetailRow = ({ label, value, icon: Icon, className = "" }) => (
  <div className={`detail-row ${className}`}>
    <dt className="detail-row__label">
      {Icon && <Icon size={14} className="detail-row__icon" />}
      {label}
    </dt>
    <dd className="detail-row__value">{value ?? "—"}</dd>
  </div>
);

/**
 * DetailSection — Wrapper for a group of DetailRows with an optional heading.
 */
const DetailSection = ({ title, children, className = "" }) => (
  <div className={`detail-section ${className}`}>
    {title && <h4 className="detail-section__title">{title}</h4>}
    <dl className="detail-section__list">{children}</dl>
  </div>
);

export { DetailRow, DetailSection };
export default DetailRow;
